import AppRouter from "./router/AppRouter";

;

function App() {
  return (
    <div>

      <AppRouter/>
    </div>
    
   
  );
}

export default App;
